import React from "react"

import { Box } from "@mui/material"

import {
    PageHeader,
    RoutesData,
} from "components/commons"
import ResearchComponent from "components/research/research-component"
import {SessionResponse} from "../../models";

interface ResearchProps
{
    sessionData: SessionResponse
}
interface ResearchState
{
}
export class Research extends React.Component<ResearchProps, ResearchState>
{
    constructor(props: ResearchProps)
    {
        super(props)
        this.state = {}
    }

    render()
    {
        return (
            <Box sx={{ width: "100%", pt: 2, position: "relative", }}>
                <PageHeader
                    title={RoutesData.RESEARCH.title}
                    paths={[ RoutesData.DASHBOARD, RoutesData.RESEARCH ]}
                />

                <ResearchComponent brands={this.props.sessionData.brands}/>

            </Box>
        )
    }
}
